import type { TrainingLessonSpecific } from './trainingLessonUi';

export const teacher1DutiesEn: TrainingLessonSpecific = {
  intro:
    'A teacher is not merely a “class teacher,” but an Aaronic Priesthood office: help members live the gospel, strengthen others, and support reverence and order. Less “I’m just passing through” and more “I care.”',
  objectives: [
    'Understand the purpose of the office of teacher in the Aaronic Priesthood.',
    'Identify key duties: strengthen, watch over, and help maintain reverence and order.',
    'Learn to correct with love (without humiliating or arguing).',
    'Practice spiritual preparation to serve (prayer, dignity, example).',
    'Create a simple weekly plan for duties (home + church).',
  ],
  briefHeading: 'Teacher duties in brief',
  briefBody:
    'A teacher strengthens members, watches over the Church with charity (not as a policeman), and helps maintain reverence and order. He corrects with gentleness, prepares with prayer and example, and plans service at home and at the meetinghouse.',
  scriptures: [
    { ref: 'D&C 20:53–59', text: 'Duties of teachers and deacons: watch over the church, be with and strengthen it.' },
    { ref: 'D&C 107:86', text: 'The duty of a teacher is to… watch over the church always…' },
    { ref: 'Moroni 6:4', text: '…nourish them with the things pertaining to righteousness…' },
    { ref: 'Galatians 6:1', text: '…restore such an one in the spirit of meekness…' },
    { ref: 'D&C 121:41–42', text: '…by persuasion, by long-suffering, by gentleness and meekness…' },
  ],
  didYouKnow: [
    'A teacher “watches over” the Church: not odd surveillance, but spiritual care and support.',
    'Correcting “with love” is not weakness: it is leadership with self-control.',
  ],
  practiceItems: [
    'Preparation: pray one minute before the meeting for reverence and charity',
    'Observe without criticizing: identify one real need (someone alone, new, distracted)',
    'Do one supportive act: greet, help find a hymn, arrange chairs, guide respectfully',
    'Practice loving correction: write two gentle phrases to invite order (e.g., “Let’s help with reverence,” “I’ll walk out with you for a moment”)',
    'Service at home: do one chore without being asked (with a good attitude)',
    'Mini journal: at day’s end write one line: “Today I helped ____ and learned ____.”',
  ],
  reflectionQuestions: [
    'What does “watching over the church” mean to me without feeling like a “police officer”?',
    'How do I react when someone corrects me? Can I correct others better than I like being corrected?',
    'What will I do this week to be an example of reverence and service?',
  ],
  actionText:
    'Care plan: choose one person (or situation) you will support this week (e.g., greet someone new, help an older member, support your family at home without complaining).',
};
